import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=bda0a5e2&scoped=true"
import script from "./rights.vue?vue&type=script&lang=js"
export * from "./rights.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=bda0a5e2&prod&scoped=true&lang=css&external"
import style1 from "./rights.vue?vue&type=style&index=1&id=bda0a5e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda0a5e2",
  null
  
)

export default component.exports